export const FBDATA_UPDATE = "FBDATA_UPDATE";
export const FBDATA_REMOVE = "FBDATA_REMOVE";
export const FBDATA_UPDATE_FEEDLIST = "FBDATA_UPDATE_FEEDLIST";
export const FBDATA_GET_FEEDLIST = "FBDATA_GET_FEEDLIST";
